module.exports = __webpack_public_path__ + "img/tt.adb11db8.svg";